module.exports = __webpack_public_path__ + "static/media/email.e07d87a2.svg";